import { useState, useEffect } from 'react';

interface NumberFilterProps {
  min?: number;
  max?: number;
  onChange: (min: number | undefined, max: number | undefined) => void;
  prefix?: string;
}

export function NumberFilter({ min, max, onChange, prefix }: NumberFilterProps) {
  const [localMin, setLocalMin] = useState(min?.toString() ?? '');
  const [localMax, setLocalMax] = useState(max?.toString() ?? '');

  // Sync with props
  useEffect(() => {
    setLocalMin(min?.toString() ?? '');
  }, [min]);

  useEffect(() => {
    setLocalMax(max?.toString() ?? '');
  }, [max]);

  const handleBlur = () => {
    const minVal = localMin ? parseFloat(localMin) : undefined;
    const maxVal = localMax ? parseFloat(localMax) : undefined;
    onChange(
      minVal !== undefined && !isNaN(minVal) ? minVal : undefined,
      maxVal !== undefined && !isNaN(maxVal) ? maxVal : undefined
    );
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <div className="flex-1">
          <label className="block text-xs text-sage-500 mb-1">Min</label>
          <div className="relative">
            {prefix && (
              <span className="absolute left-2 top-1/2 -translate-y-1/2 text-sage-400 text-sm">
                {prefix}
              </span>
            )}
            <input
              type="number"
              value={localMin}
              onChange={(e) => setLocalMin(e.target.value)}
              onBlur={handleBlur}
              placeholder="Min"
              className={`w-full px-3 py-2 text-sm border border-sage-200 rounded-lg focus:border-forest-500 focus:outline-none focus:ring-1 focus:ring-forest-500 ${
                prefix ? 'pl-6' : ''
              }`}
            />
          </div>
        </div>
        <div className="flex-1">
          <label className="block text-xs text-sage-500 mb-1">Max</label>
          <div className="relative">
            {prefix && (
              <span className="absolute left-2 top-1/2 -translate-y-1/2 text-sage-400 text-sm">
                {prefix}
              </span>
            )}
            <input
              type="number"
              value={localMax}
              onChange={(e) => setLocalMax(e.target.value)}
              onBlur={handleBlur}
              placeholder="Max"
              className={`w-full px-3 py-2 text-sm border border-sage-200 rounded-lg focus:border-forest-500 focus:outline-none focus:ring-1 focus:ring-forest-500 ${
                prefix ? 'pl-6' : ''
              }`}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
